<h1>Andamento</h1>
<div fxLayout="column" fxLayoutGap="20px">
  <app-andamento-form [isPermitirAlteracao]="true" [andamento]="andamento"> </app-andamento-form>
</div>
